<div class="page-inner-body portlet light p-1">
  <div class="portlet-body">
    <div class="border-bottom mb-3 mt-3">
      <p class="fs-5 text-dark">{{ 'notificationLists.stayUpdated' | transloco }}</p>
    </div>
    <div class="table-toolbar">
      <div class="row">
        <div class="col-12 notification-list">
          @if (isLoading) {
            <div class="text-center p-3">
              <i class="pi pi-spin pi-spinner fs-2 text-warning"></i>
              <p class="mt-2 text-dark">{{ 'notificationLists.loadingNotifications' | transloco }}</p>
            </div>
          }
          <p-table #dt [value]="notifications" [responsiveLayout]="'scroll'" [paginator]="true" [rows]="10"
            [rowsPerPageOptions]="[5, 10, 25]" styleClass="p-datatable-gridlines p-datatable-striped"
            [rowHover]="true" [globalFilterFields]="['Title','ActionType']" [paginator]="notifications.length > 10"
            [rows]="15" [reorderableColumns]="true">
            <ng-template pTemplate="body" let-rowdata>
              <tr (click)="handleNotificationClick(rowdata)" class="cursor-pointer"
                [ngClass]="{'notification-unread': !rowdata.IsRead, 'notification-read': rowdata.IsRead}">
                <td class="d-flex align-items-center p w-100">
                  <div class="d-flex align-items-start w-100 p-2">
                    <div class="flex-grow-1">
                      <div class="d-flex justify-content-between">

                        <span>
                          <i class="fa me-2"
                            [ngClass]="{'fa-bell text-success': rowdata.IsRead, 'fa-bell-slash text-danger': !rowdata.IsRead}"></i>                          <span class="fw-bold text-dark ms-2">{{ rowdata.SenderUserName }}</span>
                            <span class="badge badge-info ms-2">{{ rowdata.Title }}</span>
                          </span>
                          <small class="text-muted ms-auto">{{ rowdata.CreatedAt | date: 'short' }}</small>
                        </div>
                        <p class="m-0 cursor-pointer fw-semibold" (click)="handleNotificationClick(rowdata)">
                          <!-- {{ rowdata.Title }} -->
                        </p>
                        <p class="text-dark">{{ rowdata.Body }}</p>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="2" class="text-center text-muted">
                    <div class="text-center text-muted p-3">
                      <i class="fa fa-bell-slash fs-1"></i>
                      <p class="fs-4 mt-2">{{ 'notificationLists.noNotificationsAvailable' | transloco }}</p>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>